
import { extendTheme } from '@mui/joy/styles';


declare module '@mui/joy/styles' {
  interface PaletteBackgroundOverrides {
    appcolor: true;
    secondaryColor: true
  }
}

const theme = extendTheme({
  "colorSchemes": {
    "light": {
      "palette": {
        "primary": {
          50: '#24ABD2',
          100: '#229EC5',
          200: '#1D85AB',
          300: '#196D91',
          400: '#145677',
          500: '#10415D',
          600: '#0D334C',
          700: '#0A263A',
          800: '#071929',
          900: '#040E17',
        },
        "background": {
          "appcolor": "#10415d",
          "secondaryColor": "#65BF7A"
        }
      }
    },
    "dark": {
      "palette": {
        "primary": {
          900: '#24ABD2',
          800: '#229EC5',
          700: '#1D85AB',
          600: '#196D91',
          500: '#10415D',
          400: '#145677',
          300: '#0D334C',
          200: '#0A263A',
          100: '#071929',
          50: '#040E17',
        },
        "background": {
          "appcolor": "#10415d",
          "secondaryColor": "#65BF7A"
        }
      }
    }
  }
})


export default theme;